module.exports = __webpack_public_path__ + "img/rule1.35598507.png";